// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__jXIk2","h1":"Legal_h1__YRGvN","h2":"Legal_h2__pYrV0","h3":"Legal_h3__V9F7V","h4":"Legal_h4__TGxM8","p":"Legal_p__UghT-","ul":"Legal_ul__OdqPP"};